import { handle420 } from 'apis/HandleError';
import { handleGenericError } from 'apis/HandleError';
import { fetchdata } from './FetchData';
import { apiConfig } from 'config';

export function addComment(deviceID, user, text, recordedTime) {
  let postBody = {
    commentData: {
      user: user,
      text: text,
      recordedTime: recordedTime
    }
  };

  return fetchdata(apiConfig.cmServiceAddComment(deviceID), { method: 'POST', body: JSON.stringify(postBody) }).catch(
    (e) => {
      console.log('fetch data error = ' + e.message);
      switch (e.message) {
        case '420':
          handle420();
          break;
        default:
          handleGenericError();
      }
      return;
    }
  );
}

export function deleteComment(deviceID, commentID) {
  const auth = window.__APP_AUTH;
  const headers = {
    Accept: '*/*',
    'cache-control': 'no-cache',
    Authorization: 'Bearer ' + auth?.accessToken,
  };

  const url = apiConfig.cmServiceDeleteComment(deviceID, commentID);

  console.log('deleting', deviceID, commentID);
  return fetch(url, { method: 'DELETE', headers: headers })
    .then((response) => {
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      return response.json();
    })
    .catch((e) => {
      switch (e.message) {
        case '420':
          handle420();
          break;
        default:
          console.log(e);
          throw Error('delete Comment Failed');
      }
    });
}

export function getAllComments(deviceID) {
  return fetchdata(apiConfig.cmServiceGetAllComments(deviceID), { method: 'GET' }).catch((e) => {
    console.log('fetch data error = ' + e.message);
    switch (e.message) {
      case '420':
        handle420();
        break;
      default:
        handleGenericError();
    }
    return;
  });
}
